// DiscardControl.jsx — #57 BUILD item 2: per-POSITION discard, scoped to one stream_id via the
// new overlay plane (POST /api/ledger/overlay kind=discard). This is deliberately separate from
// MemberRow's existing top-level discard (which stays on the legacy /positions/discard route —
// that route is itself redirected server-side to the SAME overlay table for POC-mirrored tenants,
// but fans out across every position under a (portal, fund, investor) triple; a specific
// PositionSubRow needs single-stream precision instead, which only a direct stream_id-keyed
// overlay call gives).
import { useState } from "react";
import { EyeOff } from "lucide-react";
import { toast } from "sonner";
import { addOverlay } from "./overlayApi";

export default function DiscardControl({ streamId, editable, token, onDiscarded, label }) {
  const [busy, setBusy] = useState(false);

  if (!editable || !streamId) return null;

  async function handleClick(e) {
    e.stopPropagation();
    setBusy(true);
    try {
      await addOverlay({ streamId, kind: "discard", token });
      toast.success(`"${label || "Position"}" hidden — find it in Show discarded`);
      if (onDiscarded) onDiscarded();
    } catch (err) {
      toast.error("Could not discard position: " + (err?.message || "error"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className="p-1 rounded hover:bg-red-50 text-gray-300 hover:text-red-500 disabled:opacity-50 transition-colors"
      title="Discard this position (hide from view)"
      aria-label="Discard position"
      data-testid="position-discard-btn"
    >
      <EyeOff className="w-3.5 h-3.5" />
    </button>
  );
}
